// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/body/searchResultsList.styl
// module id = 523
// module chunks = 0